var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',{staticClass:"fs_16",domProps:{"textContent":_vm._s(_vm.title)}}),_c('b-table',{staticClass:"bg-white mt-3 score_competency_table",attrs:{"fields":_vm.fields,"items":_vm.wrapperItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }